/**********************************

  worldpantry.js   (Mariani)

  Cookie helpers + self-heal + early paint + guarded polling auto-trigger
  + live product-inventory functions.

  ZIP ACQUISITION: assets/worldpantry-ipzipcode.js (boss's proxy) only.
  REMOVED from the old version:
    - the exposed IPStack access_key and the api.ipstack.com call
    - the `state` cookie (set from IPStack, read nowhere -- dead)
    - geoTarget() and setTimeout(geoTarget, 1000)

  Shipping submit/display logic lives in
  snippets/worldpantry-fast-shipping-logic.liquid, which exposes
  window.wpFsRestore for the early paint below.

  The four inventory functions are preserved from the original. NOTE the
  endpoint keys are intentionally different-cased and copied VERBATIM:
    - fast-ship lookup uses  wp_2021_mariani  (lowercase, in the snippet)
    - inventory endpoints use WP_2021_MARIANI  (uppercase, below)
  Do not "normalise" these -- the server treats them as distinct strings.

***********************************/

var WP_FS = {
  cookies: {
    zip:       'zipcode',
    fsZip:     'FastShip.ZipCode',
    receiveBy: 'FastShip.ReceiveByDateTime',
    orderBy:   'FastShip.OrderByDateTime',
    calcError: 'FastShip.FastShipCalculationError'
  },
  zipInputSelector: '.zip_input',
  formSelector:     'form.js-fs-form'
};

/**********************************
  Cookie functions
***********************************/
function setSessionCookie(name, value) {
  document.cookie = name + "=" + value + "; path=/";     // fixed: was "; ; path=/"
}

function getSessionCookie(name) {
  var nameKey = name + "=";
  var cDecoded = decodeURIComponent(document.cookie);
  var cArr = cDecoded.split("; ");
  var res;
  cArr.forEach(function (val) {
    if (val.indexOf(nameKey) === 0) res = val.substring(nameKey.length);
  });
  return res;
}

function deleteCookie(name) {
  document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
}

function getCookie(e) {
  var nameEQ = e + "=";
  var ca = document.cookie.split(';');
  var result = null;
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1);
    if (c.indexOf(nameEQ) === 0) result = decodeURIComponent(c.substring(nameEQ.length));
  }
  return result;
}

function setCookie(e, t, c) {
  var expires = "";
  if (c) {
    var date = new Date();
    date.setTime(date.getTime() + (c * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = e + "=" + (t != null ? t : "") + expires + "; path=/";
}

function isValidZip(str) {
  return /^\d{5}(-\d{4})?$/.test(str || "");
}

/**********************************
  Self-heal (No Error / legacy formatted date cookies)
***********************************/
(function selfHealFastShipCookies() {
  var err = getSessionCookie(WP_FS.cookies.calcError);
  if (err) {
    var zip = getSessionCookie(WP_FS.cookies.fsZip);
    if (err === "No Error" || !isValidZip(zip)) deleteCookie(WP_FS.cookies.calcError);
  }
  var receiveBy = getSessionCookie(WP_FS.cookies.receiveBy);
  var orderBy = getSessionCookie(WP_FS.cookies.orderBy);
  // Raw ISO contains "T"; the old formatDate stored strings like "August 11".
  if ((receiveBy && receiveBy.indexOf("T") === -1) ||
      (orderBy && orderBy.indexOf("T") === -1)) {
    deleteCookie(WP_FS.cookies.receiveBy);
    deleteCookie(WP_FS.cookies.orderBy);
  }
})();

/**********************************
  Auto-trigger: early paint + first-visit poll (guarded).
***********************************/
(function wpFsAutoTrigger() {
  if (window.wpFsAutoInit) { return; }
  window.wpFsAutoInit = true;

  var jqWaits = 0;
  function whenReady() {
    if (typeof window.jQuery === 'undefined') {
      if (jqWaits++ < 50) { setTimeout(whenReady, 100); }
      return;
    }
    window.jQuery(function ($) {
      if (typeof window.wpFsRestore === 'function') {
        try { window.wpFsRestore(); } catch (e) {}
      }

      if (getSessionCookie(WP_FS.cookies.fsZip) && getSessionCookie(WP_FS.cookies.receiveBy)) {
        console.log("FastShip data already exists, skipping auto lookup");
        return;
      }

      var attempts = 0;
      function tryAutoLookup() {
        var zip = getCookie(WP_FS.cookies.zip);
        if (isValidZip(zip)) {
          console.log("fast geo zip " + zip);
          $(WP_FS.zipInputSelector).val(zip);
          $(WP_FS.formSelector).first().submit();
          return;
        }
        if (attempts++ < 20) { setTimeout(tryAutoLookup, 200); }
        else { console.log("no valid zipcode after waiting - giving up auto lookup"); }
      }
      tryAutoLookup();
    });
  }
  whenReady();
})();

/**********************************
  Product Inventory functions (preserved from the original).
  Keys copied VERBATIM -- inventory endpoints use uppercase WP_2021_MARIANI.
***********************************/

// Gets product inventory JSON data and calls the given setProductInventoryStatus function.
function getProductInventoryDisplay(zip, productId, variantId, setProductInventoryStatus) {
  var url =
    "https://shop.worldpantry.com/productinventories/mariani/productinventory.aspx";
  var postproductinventory = $.post(url, {
    zip: zip,
    key: "WP_2021_MARIANI",
    productid: productId,
    variantid: variantId,
  });
  postproductinventory.done(function (data) {
    if (data) {
      if (data.Status == "OutOfStock" || data.Status == "AlwaysSell") {
        data.StatusDisplay = "Usually ships in 1-2 weeks";
      }
      setProductInventoryStatus(data);
    }
  });
}

// Gets WorldPantry product number and variant number for each item in the current cart.
function getProductNumbers() {
  var productNumbers;
  $.ajax({
    type: "GET",
    url: "/cart?view=wp-productnumbers",
    async: false,
  }).done(function (response) {
    productNumbers = JSON.parse(response);
  });
  return productNumbers;
}

// Gets product inventories for the given list of product/variant numbers.
function getProductInventories(productNumbers) {
  var items = [];
  var productInventories;
  for (var i = 0; i < productNumbers.length; i++) {
    var item = {};
    item["productId"] = productNumbers[i].productNumber;
    item["variantId"] = productNumbers[i].variantNumber;
    items.push(item);
  }

  if (items) {
    var shippingInfo = new Object();
    shippingInfo.zip = getCookie("zipcode");
    shippingInfo.items = items;
    var url =
      "https://shop.worldpantry.com/productinventories/mariani/productinventories.aspx";
    $.ajax({
      type: "POST",
      url: url,
      data: {
        key: "WP_2021_MARIANI",
        shippingInfo: JSON.stringify(shippingInfo),
      },
      async: false,
    }).done(function (data) {
      productInventories = data;
    });
  }
  return productInventories;
}

// Gets a product inventory status display for the cart.
function getProductInventoryCartStatusDisplay(productInventories) {
  var inventoryCartStatusDisplay = "Standard";
  var AlwaysSellCartStatusDisplay =
    "One or more products is out of stock. Your order should ship in 1-2 weeks.";
  if (productInventories) {
    for (var i = 0; i < productInventories.length; i++) {
      if (
        productInventories[i].Status == "AlwaysSell" ||
        productInventories[i].Status == "OutOfStock"
      ) {
        inventoryCartStatusDisplay = AlwaysSellCartStatusDisplay;
        break;
      }
    }
  }
  return inventoryCartStatusDisplay;
}

// Gets a product inventory for the given product ID.
// Guarded: skips records with a missing ProductId/VariantId rather than
// throwing on .toUpperCase() of undefined (which killed the PDP render).
function getProductInventory(id, productNumbers, productInventories) {
  var inventoryStatus;
  for (var n = 0; n < productNumbers.length; n++) {
    if (productNumbers[n].id == id) {
      var productNumber = productNumbers[n].productNumber;
      var variantNumber = productNumbers[n].variantNumber;
      for (var i = 0; i < productInventories.length; i++) {
        if (
          productInventories[i].ProductId &&
          productInventories[i].VariantId &&
          productInventories[i].ProductId.toUpperCase() == productNumber.toUpperCase() &&
          productInventories[i].VariantId.toUpperCase() == variantNumber.toUpperCase()
        ) {
          inventoryStatus = productInventories[i];
          break;
        }
      }
      break;
    }
  }
  return inventoryStatus;
}
